import React, { useContext, useEffect, useState } from 'react';
import { Upload } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import { AppContext } from '../../../../contexts/AppContext';
import { ChartTitle } from '@meteor/frontend-core';
const { Dragger } = Upload;

const PlaceholderContainer: React.FC<any> = (props) => {
  const { property, disabled = false } = props;
  const { indexDbStorage } = useContext(AppContext);
  const [imageData, setImageData] = useState<any>(null);
  const [loading, setLoading] = useState<any>(true);

  const getBase64 = (file: any): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  };

  const uploadProps = {
    name: 'file',
    showUploadList: false,
    beforeUpload: async (file) => {
      const base64 = await getBase64(file);
      setImageData(base64);
      await indexDbStorage.setItem(property.i, base64);
      return false;
    },
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files);
    },
  };
  const hasImageUrl = property && property.imageUrl && property.imageUrl.length > 0;

  useEffect(() => {
    indexDbStorage.getItem(property.i).then((data) => {
      if (data) {
        setImageData(data);
      }
      setLoading(false);
    });
  }, []);

  const hasTitle = property && property.title && property.title.length > 0;

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%', padding: 20 }}>
      {hasTitle ? (
        <ChartTitle
          title={{
            value: property.title,
          }}
        />
      ) : (
        <></>
      )}
      {loading ? (
        <></>
      ) : (
        <Dragger
          {...uploadProps}
          disabled={!property.useUpload || disabled}
          className={
            (!property.useUpload || disabled ? 'disabled-upload placeholder-upload' : 'placeholder-upload') +
            (hasTitle ? ' placeholder-title' : '')
          }
        >
          {imageData || hasImageUrl ? (
            <div
              style={{
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: property.backgroundPosition || 'center center',
                backgroundImage: `url(${property.useUpload ? imageData : property.imageUrl})`,
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
              }}
            ></div>
          ) : (
            <>
              <p className="dynamic-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="dynamic-upload-text">Click or drag image file to this area to upload</p>
              <p className="dynamic-upload-hint">This is a placeholder for non-implement component.You can upload a image for static.</p>
            </>
          )}
        </Dragger>
      )}
    </div>
  );
};

export default PlaceholderContainer;
